import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import { TextSeparatorPresentationProps } from "@store/Library/Components/Toolkit/TextSeparator";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

interface SignInSharedProps {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export interface SignInProps extends SignInSharedProps {
    separator?: TextSeparatorPresentationProps;
    overlayOverrides?: SignInSharedProps;
}

export const signInProps: SignInProps = {
    wrapper: {
        css: css`
            ${breakpoint("md")} {
                ${boxStyles(pxToRemArray([null, null, 20, 32, 48]))};
                height: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
        css: css`
            margin-top: 0;
        `,
    },
    icon: {
        color: "primary",
        size: 60,
        css: spacingStyles(null, pxToRem(10)),
    },
    separator: {
        spacing: pxToRemArray([16]),
        extendedStyles: {
            text: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.smaller};
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.small};
                `,
            },
        },
    },
    overlayOverrides: {
        wrapper: {
            css: css`
                &:not(#important) {
                    box-shadow: none;
                    padding: 0;
                    height: auto;
                    background: transparent;
                    border-radius: 0;
                }
            `,
        },
        title: {
            forwardAs: "p",
            css: css`
                font-size: ${x => x.theme.design.typography.size.large} !important;
            `,
        },
    },
};
